<template>
  <div class="info-container">
    <div class="info-border">
      <div
        class="cell-margin"
        @click="changeRelation">
        <mt-cell
          title="关系"
          is-link>
          <p>{{ relationship }}</p>
        </mt-cell>
      </div>
      <mt-actionsheet
        :actions="selectRelation"
        v-model="chooseRelation"/>
    </div>
    <div class="fy-cell info-border">
      <div class="title">
        <span>手机号</span>
      </div>
      <div class="text">
        <input
          v-model="phone"
          type="tel"
          class="input-name"
          placeholder="请输入"
          @blur="getDatas">
      </div>
    </div>
    <div class="fy-cell info-border">
      <div class="title">
        <span>申请人姓名</span>
      </div>
      <div class="text">
        <input
          v-model="name"
          type="text"
          class="input-name"
          placeholder="请输入">
      </div>
    </div>
    <div class="info-border">
      <div
        class="cell-margin"
        @click="changeSex">
        <mt-cell
          title="性别"
          is-link>
          <p>{{ sexvalue }}</p>
        </mt-cell>
      </div>
      <mt-actionsheet
        :actions="selectSex"
        v-model="chooseSexVisible"/>
    </div>
    <div class="fy-cell">
      <div class="title">
        <span>二代身份证</span>
      </div>
      <div class="text">
        <input
          v-model="identityCard"
          type="text"
          class="input-name"
          placeholder="请输入">
      </div>
    </div>
    <div style="margin:0 10px">
      <mt-button
        v-if="show"
        type="primary"
        size="large"
        style="margin-top:44px"
        @click="createCard">在线立即建档</mt-button>
      <div
        v-if="!show"
        class="d-flex justify-content-center new-card">
        <mt-spinner
          :size="60"
          color="#26a2ff"
          type="triple-bounce"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import Cookies from 'js-cookie';
import format from 'date-fns/format';
import locale from 'date-fns/locale/zh_cn';

export default {
  name: 'CardBind',
  data() {
    return {
      chooseRelation: false, // 选择关系的模态框
      relationship: '请选择', // 当前关系
      name: '', // 姓名
      identityCard: '', // 身份证
      phone: '', // 电话
      sexvalue: '请选择', // 性别
      chooseSexVisible: false, // 选择性别的模态框
      birthday: format(new Date(2000, 0, 1), 'YYYY-MM-DD', { locale }), // 出生日期
      show: true,
      start: false,
      list: [],
      selectRelation: [
        {
          name: '本人',
          method: this.selectRela,
        },
        {
          name: '父母',
          method: this.selectRela,
        },
        {
          name: '子女',
          method: this.selectRela,
        },
        {
          name: '兄弟姐妹',
          method: this.selectRela,
        },
        {
          name: '伴侣',
          method: this.selectRela,
        },
        {
          name: '其他',
          method: this.selectRela,
        },
      ],
      selectSex: [
        {
          name: '男',
          method: this.selectMan,
        },
        {
          name: '女',
          method: this.selectWoman,
        },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const url = '/patient-api/webapi/user/list-medical-card';
      const config = {
        params: {
          access_token: Cookies.get('token'),
          hospital_id: '',
        },
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      };
      const response = await this.$http.get(url, config);
      this.list.push(...response.list);
    },
    getDatas() {
      this.list.forEach((item) => {
        if (item.phone === this.phone && item.relation === this.relationship) {
          if (item.medical_card_id !== null) {
            this.phone = item.phone;
            this.name = item.name;
            this.sexvalue = item.sex;
            this.identityCard = item.id_card_code;
          }
        }
      });
    },
    // 显示选择关系的模态框
    changeRelation() {
      this.chooseRelation = true;
    },
    // 选择关系的方法
    selectRela(value) {
      this.relationship = value.name;
    },
    // 正则判断
    regExp() {
      if (this.name === '') {
        Toast({
          message: '请输入姓名',
          position: 'bottom',
        });
        return 0;
      }
      if (this.identityCard === null) {
        this.identityCard = '';
      }
      const testNum = this.identityCard.replace(/\s+/g, '');
      const regIdNo = /(^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/;
      if (!regIdNo.test(testNum)) {
        Toast({
          message: '请输入正确身份证号',
          position: 'bottom',
        });
        return 0;
      }
      this.identityCard = this.identityCard;
      let { phone } = this;
      if (phone === null) {
        phone = '';
      }
      const phoneNum = phone.replace(/\s+/g, '');
      const regPhone = /(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/;
      if (!regPhone.test(phoneNum)) {
        Toast({
          message: '手机号格式错误',
          position: 'bottom',
        });
        return 0;
      }
      this.phone = phone;
      if (this.relationship === '请选择') {
        Toast({
          message: '请选择医院',
          position: 'bottom',
        });
        return 0;
      }
      if (this.sexvalue === '请选择') {
        Toast({
          message: '请选择医院',
          position: 'bottom',
        });
        return 0;
      }
      return 1;
    },
    // 选择性别的方法
    changeSex() {
      this.chooseSexVisible = true;
    },
    // 选择男的方法
    selectMan() {
      this.sexvalue = '男';
      this.chooseSexVisible = false;
    },
    // 选择女的方法
    selectWoman() {
      this.sexvalue = '女';
      this.chooseSexVisible = false;
    },
    // 在线立即建档的方法
    async createCard() {
      let { hospitalId } = this.$route.query;
      if (!hospitalId) {
        hospitalId = this.$store.state.fuyiHospitalId;
      }
      const value = this.regExp();
      const year = this.identityCard.slice(6, 10);
      const month = this.identityCard.slice(10, 12);
      const day = this.identityCard.slice(12, 14);
      const birth = year + '-' + month + '-' + day; // eslint-disable-line prefer-template
      if (value === 1) {
        this.show = false;
        const params = {
          phone: this.phone,
          id_card_code: this.identityCard,
          name: this.name,
          relation: this.relationship,
          gender_name: this.sexvalue,
          birth_date: birth,
          hospital_id: hospitalId,
        };
        const url = '/patient-api/system-api/webapi/user/create-medical-card';
        const config = {
          headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        };
        await this.$http.post(url, params, config).then(() => {
          Toast({
            message: '绑定成功',
            duration: 1000,
          });
          this.$router.go(-2);
          this.show = true;
        }).catch(() => {
          this.show = true;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .info-container{
    margin-top:5px;
  }
  .info-border{
    border-bottom: 1px solid #dee2e6;
  }
  .new-card{
    padding-top: 8px;
  }
  .fy-cell {
    display: flex;
    justify-content: space-between;
    height: 47px;
    align-items: center;
    background-color: white;
    .title {
      margin-left: 10px;
    }
    .text {
      margin-right: 15px;
      color: gray;
      // 添加
      height: 45px;
      display: flex;
      align-items: center;
      .input-name {
        border:none;
        outline:none;
        font-size: 16px;
        text-align:right;
        color: gray;
        -webkit-tap-highlight-color:rgba(255,0,0,0);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/user/card-bind.vue